export const imageConstants = {
  mobileNavToggle: {
    url: "https://images.ctfassets.net/qc3lz96t0r4x/2GVW0xVj8nslVrxyr3BhMJ/0e2b5b464046b58f424c776ecf2e68ca/mobile-nav-toggle.svg",
    title: "Mobile Nav toggle",
    description: "Mobile Nav toggle",
    height: 52,
    width: 50,
  },
  close: {
    url: "https://images.ctfassets.net/qc3lz96t0r4x/43lX9DsnYw5JPOhi1EyLrD/acc1f786724ddacf2785fb6d8f278870/close-icon.png",
    title: "Close",
    description: "Close",
    height: 50,
    width: 40,
  },
  arrowRight: {
    url: "https://images.ctfassets.net/qc3lz96t0r4x/1iF5RBHzCH7p9Ss2GxRmMO/46fe9f44a118db06fe9c184d5c28ea43/arrow-right.svg",
    title: "arrow right",
    description: "arrow right",
   
  },
  arrowDown: {
    url: "https://images.ctfassets.net/qc3lz96t0r4x/7qSI4tE8IbOspSsOlTAWbT/5f59076e5eb00261a52474652b4a0552/arrow.png",
    title: "arrow Down",
    description: "arrow down",
    height: 20,
    width: 12,
  },
  playBtnWhite: {
    url: "https://images.ctfassets.net/zo243s55pyir/6Sc6cgTKKinfqx9B9PpTqt/1c8ff4a34e3feb0c8ef991ecb3580d49/play-button.png",
    title: "Play Button",
    description: "Load Video",
    height: 72,
    width: 72,
  },
  playBtnBlack: {
    url: "https://images.ctfassets.net/zo243s55pyir/63qCkcl8iEMrqQCBr6hvIU/bc4cb96f6e2a4f7d78015c447f6781e7/play-button-black.svg",
    title: "Play Button",
    description: "Load Video",
    height: 72,
    width: 72,
  },
  recipeFilterType: {
    url:"https://images.ctfassets.net/qc3lz96t0r4x/7FI2Uwzjcp0rhWoubYPsig/41b649cef7370bd45894844462ff4677/98220.png",
    title: "Type of Philadelphia",
    description: "Type of Philadelphia",
    height: 200,
    width: 200,
  },
  print: {
    url:"https://images.ctfassets.net/zo243s55pyir/4KfZ99GVWFUmUU9IagZhO8/ec656d30435d06de60744112ec66b279/print.png?h=250",
    title: "print",
    description: "print",
    height: 32,
    width: 32,
  },
  searchCareersOrange:{
    url: "https://images.ctfassets.net/zo243s55pyir/41J57D4a8H61xFmQK4YRDu/6684702e8c3e77ea6d163bdfa9cac02f/search-careers-orange.png",
    title: "searchCareersOrange",
    description: "searchCareersOrange",
    height: 50,
    width: 50,
  },
  greenArrow: {
    url: "https://images.ctfassets.net/zo243s55pyir/5zjBHuJam6jIJE1VTdSzO/19d8500eaabc29c53bd9cb0fd4172dd0/green-arrow.png",
  }
}


